import React from 'react';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import StyledCard from '../../components/StyledCard';

export default function DraftPOCount({ purchaseOrders }) {
  const draftOrders = purchaseOrders.filter(order => order.status === 'draft');
  const count = draftOrders.length;

  return (
    <StyledCard
      title="Draft PO Count"
      titleIcon={PendingActionsIcon}
    >
      <CardContent>
        <Typography
          variant="h1"
          sx={{ textAlign: 'center' }}
        >
          <Box>
            {count}
          </Box>
        </Typography>
      </CardContent>
    </StyledCard>
  );
} 